export default [
	"en",
	"de",
	"sv",
	"hu",
	"ckb",
	"pt_BR",
	"pt_PT",
	"fr",
	"br",
	"lv",
	"ar",
	"ru",
	"uk",
	"et",
	"fil",
	"fa",
	"es",
	"pl",
	"id",
	"owo",
	"el",
	"nb_NO",
	"ca",
	"it",
	"zh_Hant",
	"lt",
	"tokipona",
	"sk",
	"tr",
	"ja",
	"esperanto",
	"hi"
]